import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class DisputesService extends AbstractService {
	static disputesApi = NexusService.disputesApi;

	static nonRKPayInvoiceApi = NexusService.nonRKPayInvoiceApi;

	static getDisputeById(id) {
		return this.disputesApi.getDispute({ id }).then(response => response);
	}

	static updateDisputeReason(id, data) {
		return this.disputesApi.updateDisputeReason({ id, updateDisputeReasonRequestModel: data }).then(response => response);
	}

	static getDisputeHistory(invoiceId) {
		return this.nonRKPayInvoiceApi.getDisputesSummaryByInvoice({ id: invoiceId }).then(response => response);
	}
}
